const getUserConfig = (state: WebOrder.State) =>
  state.flipdish.Customer &&
  state.flipdish.Customer.status === 'success' &&
  state.flipdish.Customer.data;

const isLoggedIn = (state: WebOrder.State) =>
  state.flipdish.Customer && state.flipdish.Customer.status === 'success';

export const userSelectors = {
  getUserConfig,
  isLoggedIn,
};
